import { render } from "./DocsLayout.vue?vue&type=template&id=e0e675b6&scoped=true"
import script from "./DocsLayout.vue?vue&type=script&lang=js"
export * from "./DocsLayout.vue?vue&type=script&lang=js"

import "./DocsLayout.vue?vue&type=style&index=0&id=e0e675b6&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0e675b6"]])

export default __exports__